import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import type { CreateMasterProductFamilyPayload, MasterProductFamily } from './types';
import { masterProductFamiliesEndpoint } from './use-get-master-product-families-api';

type TData = MasterProductFamily;
type TError = AxiosError;
type TVariables = CreateMasterProductFamilyPayload;

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

// POST api/v1/cms/master-product-families — response body is { data: MasterProductFamily }.
export function useCreateMasterProductFamilyApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async (data: TVariables): Promise<TData> => {
    const response = await http.post(masterProductFamiliesEndpoint, data);
    return response.data.data;
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: [masterProductFamiliesEndpoint],
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([masterProductFamiliesEndpoint]);
      userOnSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
}
